const mEditionMapEnrollmentsFamiliesMembers = {
  mEditionMapEnrollmentsFamiliesMembers: {
    alerts: {
      deleteFamiliaMiembro: {
        error: 'Un error ha ocurrido. Espera un momento y vuelve a intentarlo.',
        success: 'Se eliminó correctamente el integrante.'
      },

      readFamiliasExportar: {
        error: 'Un error ha ocurrido. Espera un momento y vuelve a intentarlo.',
        success: 'Listado de equipos descargado.'
      },

      updateFamiliaLider: {
        activationSuccess: 'El lider fue asignado exitosamente.',
        deactivationSuccess: 'El lider fue desactivado exitosamente.',
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.'
      }
    },

    buttonPrimary: 'Descargar CSV',

    buttonSecondary: {
      createText: 'Agregar Integrante',
      filterText: 'Filtros Avanzados'
    },

    files: {
      family: 'Equipos'
    },

    table: {
      thCountry: 'País',
      thDelete: 'Eliminar',
      thLeader: 'Líder',
      thMember: 'Integrante',
      thScore: 'Puntaje'
    },

    tooltip: {
      delete: 'Eliminar Integrante',
      reload: 'Actualizar'
    }
  }
}

export default mEditionMapEnrollmentsFamiliesMembers
